module.exports = __webpack_public_path__ + "img/about-us.449e537b.jpg";